import { useSiteTourStep } from 'my-core/hooks';

export default function ({ children, disabled, step, tourId }) {
  const elementId = useSiteTourStep({ disabled, step, tourId });
  return children(elementId);
}
